var SecondaryNavigation = {
    constants: {
        $expandButton: $(".SecondaryNavigation-expandButton"),
        $level1List: $(".SecondaryNavigation-level1List")
    },

    toggleMobile: function () {
        var $expandButton = SecondaryNavigation.constants.$expandButton,
            $level1List = SecondaryNavigation.constants.$level1List;

        $expandButton.on("click", function () {
            var $this = $(this);
            $this.toggleClass("is-expanded");
            $level1List.toggleClass("d-none");
        })
    },
    

    init: function () {
        SecondaryNavigation.toggleMobile();
    }
}

$(function () {
    SecondaryNavigation.init();
});
